<template>
  <div class="wrap short">
    <div class="title">Bookings</div>
    <div class="subtitle">{{ this.totalBookings | formatNumbers }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    stats: {
      type: Object,
      required: true,
    },
    customerid: {
      type: String,
      required: false,
    },
    customers: {
      type: Array,
      required: true,
    },
    region: {
      type: String,
      required: false,
    },
  },
  data: function () {
    return {
      totalBookings: 0,
    };
  },
  methods: {
    CountBookings: async function () {
      const today = this.stats[Object.keys(this.stats)[Object.keys(this.stats).length - 1]];
      for (const [time, customerData] of Object.entries(today)) {
        if (this.customerid > 0) {
          if (customerData[this.customerid].Booked) {
            this.totalBookings += customerData[this.customerid].Booked;
          }
        } else if (this.region > 0) {
          for (const [customerId, customData] of Object.entries(customerData)) {
            if (this.customers[customerId].region_id == this.region) {
              for (const [outcome, count] of Object.entries(customData)) {
                if (outcome.toLowerCase() === "booked") {
                  this.totalBookings += count;
                }
              }
            }
          }
        } else {
          for (const [customerId, customData] of Object.entries(customerData)) {
            for (const [outcome, count] of Object.entries(customData)) {
              if (outcome.toLowerCase() === "booked") {
                this.totalBookings += count;
              }
            }
          }
        }
      }
    },
  },
  filters: {
    formatNumbers: function (value) {
      return value.toLocaleString();
    },
  },
  mounted() {
    this.CountBookings();
  },
};
</script>

<style scoped>
.wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.title {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.subtitle {
  font-size: min(5vw, 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
